export const retroScrollbarStyles = `
  .scrollbar-retro::-webkit-scrollbar { width: 16px; }
  .scrollbar-retro::-webkit-scrollbar-track { background: #dfdfdf; box-shadow: inset 1px 1px #808080, inset -1px -1px #ffffff; }
  .scrollbar-retro::-webkit-scrollbar-thumb { background: #c0c0c0; border: 2px solid; border-color: #ffffff #808080 #808080 #ffffff; }
  .scrollbar-retro::-webkit-scrollbar-button { background: #c0c0c0; border: 1px solid; border-color: #ffffff #808080 #808080 #ffffff; display: block; height: 16px; }
  .scrollbar-retro::-webkit-scrollbar-button:start:increment { display: none; }
  .scrollbar-retro::-webkit-scrollbar-button:end:decrement { display: none; }
`;

export const retroBtnClass =
    'bg-[#c0c0c0] text-black border-t-2 border-l-2 border-white border-b-2 border-r-2 border-[#808080] active:border-t-2 active:border-l-2 active:border-[#808080] active:border-b-2 active:border-r-2 active:border-white px-2 py-1 md:px-3 text-xs md:text-sm font-sans focus:outline-none flex items-center justify-center gap-1 md:gap-2 cursor-pointer disabled:opacity-50';

export const retroWindowClass =
    'bg-[#c0c0c0] border-t-2 border-l-2 border-white border-b-2 border-r-2 border-[#808080] shadow-[2px_2px_0px_0px_rgba(0,0,0,0.5)] font-sans text-black flex flex-col';

export const retroSunkenClass =
    'bg-white border-t-2 border-l-2 border-[#808080] border-b-2 border-r-2 border-white';

export const retroFieldClass =
    'w-full bg-white border-t-2 border-l-2 border-[#808080] border-b-2 border-r-2 border-white px-2 py-1 text-sm font-sans focus:outline-none';

export const retroTabClass = (isActive) => `px-3 py-1 text-xs md:text-sm border-t-2 border-l-2 border-r-2 rounded-t-sm focus:outline-none ${
    isActive
        ? 'bg-[#c0c0c0] border-white border-r-[#808080] pb-2 -mb-[2px] z-20 font-bold'
        : 'bg-[#a0a0a0] border-white border-r-[#808080] mt-[2px] cursor-pointer'
}`;

export const formatMailDate = (value) => {
    if (!value) return '';
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? '' : parsed.toLocaleString('en-GB');
};
